var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconAddPerson = function SvgIconAddPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2v-2a1 1 0 0 1 1-1Zm-7-2c1.248 0 2.662.21 4.001.58v2.088C11.68 12.254 10.164 12 9 12c-1.414 0-3.346.374-4.818.955-.737.29-1.359.637-1.737.951-.34.283-.428.485-.443.57L2 14.5v.5h8v2H0v-2.5c0-.9.537-1.608 1.166-2.13.629-.524 1.414-.931 2.283-1.274C5.187 10.41 7.255 10 9 10ZM9 0c2.197 0 4 1.803 4 4s-1.803 4-4 4-4-1.803-4-4 1.803-4 4-4Zm0 2c-1.116 0-2 .884-2 2s.884 2 2 2 2-.884 2-2-.884-2-2-2Z"
  })));
};

export default SvgIconAddPerson;